export enum PlayState {
    Stopped = "stopped",
    Buffering = "buffering",
    Playing = "playing",
    Paused = "paused",
    Error = "error"
}
